export class DashBoard {
   OrderStatus: string;                                                                                                 
}

export class DashBoardLatestOrders {
   id: number;
   orderId: number;
   orderStatus: string;
   priceFormatted: number;
   dateFormatted: string;
   productName: string;
   totalPriceFormatted: string;

}